var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRowMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 12,
    viewBox: "0 0 4 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 4.4375C1.01172 4.4375 0.4375 5.03906 0.4375 5.75C0.4375 6.48828 1.01172 7.0625 1.75 7.0625C2.46094 7.0625 3.0625 6.48828 3.0625 5.75C3.0625 5.03906 2.46094 4.4375 1.75 4.4375ZM0.4375 1.59375C0.4375 2.33203 1.01172 2.90625 1.75 2.90625C2.46094 2.90625 3.0625 2.33203 3.0625 1.59375C3.0625 0.882813 2.46094 0.28125 1.75 0.28125C1.01172 0.28125 0.4375 0.882813 0.4375 1.59375ZM0.4375 9.90625C0.4375 10.6445 1.01172 11.2188 1.75 11.2188C2.46094 11.2188 3.0625 10.6445 3.0625 9.90625C3.0625 9.19531 2.46094 8.59375 1.75 8.59375C1.01172 8.59375 0.4375 9.19531 0.4375 9.90625Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowMenu);
export default __webpack_public_path__ + "static/media/RowMenu.38c51870a2ee372392e749e50dbafb8d.svg";
export { ForwardRef as ReactComponent };